import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsAdd.vue?vue&type=template&id=0c5a2f82&scoped=true&"
import script from "./MonthAllowancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a2f82",
  null
  
)

export default component.exports